import route, { InputParams } from 'ziggy-js'

export default abstract class RouteBase{
  protected abstract readonly prefix: string

  ziggyRoute(route_name: string, params?: InputParams): string{
    return route(this.prefix + route_name, params).toString()
  }
}

export abstract class ApiRoute extends RouteBase {
  protected abstract readonly prefix: string

  get apiPrefix() {
    return 'api.v1.' + this.prefix
  }

  ziggyRoute(route_name: string, params?: InputParams): string {
    return route(this.apiPrefix + route_name, params).toString()
  }
}
